module.exports = __webpack_public_path__ + "img/arschkarte_px.81aed05e.png";